import { IUserListResponse } from "@/types";
import { fetcher } from "@/utils/api/dataverse/fetcher";
export const URL = {
  appRole: "/AppRoleApi",
  assignRole: "/AssignRole",
  users: "/UsersApi",
};

export const getCurrentUserApi = async (
  email: string,
): Promise<IUserListResponse> => {
  return await fetcher(
    `${URL.users}?$filter=contains(internalemailaddress,'${email}') &$expand=dogma_AppRole_SystemUser_SystemUser($select=dogma_defaultsecurityrole,dogma_name,dogma_permissionsjson)`,
  );
};
